import { CenterSpinner } from '@/Domain/components/Shared/CenterSpinner/CenterSpinner';
import { useSubscription } from '@/Domain/components/SubscriptionProvider';
import { useConversationTopicsList } from '@/Domain/hooks/Conversation/useConversationTopicsList.hook';
import { ManageTopicsProtected } from '@/UI/Insights/ManageTopics/ManageTopics.protected';
import { MangeTopicsPage } from '@/UI/Insights/ManageTopics/MangeTopics.page';

export const ManageTopicsLoader = () => {
  const query = useConversationTopicsList();
  const { getConfig, isFetched } = useSubscription();

  const isTopicActive = getConfig('topics');

  if (!isFetched || query.isLoading) {
    return <CenterSpinner />;
  }

  if (!isTopicActive) {
    return <ManageTopicsProtected />;
  }

  return <MangeTopicsPage topics={query.data || []} />;
};
